module.exports = require('./dist/pure.js');



//////////////////
// WEBPACK FOOTER
// ../~/@stripe/stripe-js/pure.js
// module id = 1781
// module chunks = 121